import { render, staticRenderFns } from "./ModalRecommend.vue?vue&type=template&id=55a6ab52&scoped=true&"
import script from "./ModalRecommend.vue?vue&type=script&lang=js&"
export * from "./ModalRecommend.vue?vue&type=script&lang=js&"
import style0 from "./ModalRecommend.vue?vue&type=style&index=0&id=55a6ab52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a6ab52",
  null
  
)

export default component.exports